<template>
  <div :class="topClassName">
    <app-navigation></app-navigation>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
  import AppNavigation from './shared/AppNavigation.vue';
  
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';


  export default {
    data: () => ({
        fullPage: true,
        colorless: true
    }),
    components: {
      'app-navigation': AppNavigation,
      'loading': Loading
    },
    computed: {
      isLoading() {
        return this.$store.getters.isLoading
      },
      topClassName() {
        let className = !this.colorless ? 'bg-colored' : ''
        let className2 = this.$store.getters.selectedLanguage ? 'lang-' + this.$store.getters.selectedLanguage.key : 'lang-ja'
        return className + ' ' + className2
      },
      isColorless() {
        return this.colorless
      },
      langType() {
        return this.$store.getters.selectedLanguage ? this.$store.getters.selectedLanguage.key : ''
      }
    },
    watch: {
      $route(to, from) {
        if((!/^(apps|lesson|login|^profile\.)/.test(to.name) && to.name != 'inquiry.message')
              || (to.name == 'lesson' || to.name == 'lesson.category' || to.name == 'profile.situation'
              || to.name == 'profile.situation.detail')) {
          this.colorless = false
        } else {
          this.colorless = true
        }
      }
    },
    created() {
      let currentHistory = this.$router.history.current
      
      if((!/^(apps|lesson|login|^profile\.)/.test(currentHistory.name) && currentHistory.name != 'inquiry.message')
        || (currentHistory.name == 'lesson' || currentHistory.name == 'lesson.category' || currentHistory.name == 'profile.situation'
        || currentHistory.name == 'profile.situation.detail')) {
        this.colorless = false
      } else {
        this.colorless = true
      }
    }
  }
</script>
